import SubmitButton from "../../components/atoms/Buttons/SubmitButton";
import { Form, Input, Modal, message } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import CustomLoader from "../../utils/CustomLoader";
import moment from "moment";
import { getUserListWithDetailThunk } from "../../store/thunks/masterDataThunk";
import {
  getDelegateAccesUserDetailThunk,
  undelegateAccessThunk,
} from "../../store/thunks/delegateAccessThunk";
import { bumpDelegatedAccessVersion } from "../../store/slices/delegateAccessSlice";
//import { updateUserDelegationFlags } from "../../store/slices/authSlice";

const UndelegateAccess = (props) => {
  // --------------------------
  // PROPS
  // --------------------------
  const { isVisible, setIsVisible, givenDelegatedAccess, storeLIUId } = props;

  //Dispatch + Custom Hooks
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  // Ref to avoid duplicate messages
  const didFetchRef = useRef(false);

  // --------------------------
  // REDUX STATE
  // --------------------------

  // --------------------------
  // LOCAL STATES
  // --------------------------
  const [showLoader, setShowLoader] = useState(false);
  const [users, setUsers] = useState([]);
  const [delegatedAccessInfo, setDelegatedAccessInfo] = useState([]);
  const [delegatedAccessUsers, setDelegatedAccessUsers] = useState([]);
  const [collapseClass, setCollapseClass] = useState("");

  // --------------------------
  // USE EFFECTS
  // --------------------------
  const fetchData = async () => {
    try {
      setShowLoader(true);

      const usersRes = await dispatch(getUserListWithDetailThunk()).unwrap();
      setUsers(usersRes || []);

      const payload = { fetch: "assignByInfo", assignBy: storeLIUId };
      const delegateRes = await dispatch(
        getDelegateAccesUserDetailThunk(payload),
      ).unwrap();

      if ((!delegateRes || delegateRes.length === 0) && !didFetchRef.current) {
        setDelegatedAccessInfo([]);
        setDelegatedAccessUsers([]);

        // dispatch(
        //   updateUserDelegationFlags({
        //     hasDelegatedAccess: false,
        //     givenDelegatedAccess: false,
        //   })
        // );

        didFetchRef.current = true;
        return;
      }
      setDelegatedAccessInfo(delegateRes || []);

      // Resolve user AFTER users state is fetched
      const mappedUsers = delegateRes
        .map((d) => usersRes.find((u) => u.id === d.assignTo))
        .filter(Boolean);

      setDelegatedAccessUsers(mappedUsers);
      didFetchRef.current = true;
    } finally {
      setShowLoader(false);
    }
  };
  useEffect(() => {
    if (!isVisible) return;
    fetchData();
  }, [isVisible, dispatch, storeLIUId]);

  const closeModal = () => setIsVisible(false);

  const onFinish = async () => {
    const activeDelegation = delegatedAccessInfo?.[0];

    if (!activeDelegation?._id) {
      message.warning("No active delegated access found to revoke");
      return;
    }
    try {
      setShowLoader(true);
      const payload = {
        delegateAccessId: activeDelegation?._id,
        updatedAt: new Date().toISOString(),
        historySource: "fromUser",
        historyAction: "update",
        historyUserID: storeLIUId,
        route: "revokeDelegateAccess",
      };

      await dispatch(undelegateAccessThunk(payload)).unwrap();

      message.success("Delegated access has been revoked successfully");
      dispatch(bumpDelegatedAccessVersion());
      await fetchData(); // refresh data

      closeModal();

      // setDelegatedAccessInfo(null);
      // setDelegatedAccessUsers(null);

      // dispatch(
      //   updateUserDelegationFlags({
      //     hasDelegatedAccess: false,
      //     givenDelegatedAccess: false,
      //   })
      // );
      // closeModal?.();
      // await fetchData?.();
    } catch (err) {
      console.error(err);
      message.error("Failed to revoke delegated access");
    } finally {
      setShowLoader(false);
      //closeModal();
      //await fetchData?.();
    }
  };

  const handleSubmit = () => {
    form.submit();
  };

  // ---------------------------
  // CONFIRM MODAL
  // ---------------------------
  const showConfirm = () => {
    Modal.confirm({
      title: "Revoke delegated access?",
      content:
        "This will immediately remove the delegate's permissions and notify the delegated user.",
      okText: "Yes",
      cancelText: "No",
      maskClosable: false,
      className: "revokeOrDeleteConfirmModal",
      okButtonProps: {
        className: "defaultbutton",
      },
      cancelButtonProps: {
        className: "defaultWhiteBtn",
      },
      onOk: async () => {
        //setShowLoader(true);
        await onFinish();
      },
    });
  };

  // --------------------------
  // JSX RETURN
  // --------------------------
  return (
    <>
      {showLoader && <CustomLoader />}

      <Modal
        className="custom-modal"
        title="Revoke delegated access?"
        open={isVisible}
        onCancel={closeModal}
        footer={[
          <SubmitButton
            key="cancel"
            type="primary"
            className="btn px-5 py-2 defaultWhiteBtn rounded-lg"
            submitName="Cancel"
            onClick={closeModal}
          />,

          <SubmitButton
            key="revoke"
            type="primary"
            htmlType="submit"
            submitName="Revoke"
            className="btn px-5 py-2 defaultbutton rounded-lg"
            // onClick={() => {
            //   const confirmModal = Modal.confirm({
            //     title: "Revoke delegated access?",
            //     content:
            //       "This will immediately remove the delegate's permissions and notify the delegated user.",
            //     closable: true,
            //     maskClosable: false,
            //     footer: [
            //       <div
            //         className="d-flex justify-content-end"
            //         style={{ gap: "6px" }}
            //       >
            //         <SubmitButton
            //           key="no"
            //           type="primary"
            //           submitName="No"
            //           className="defaultWhiteBtn"
            //           onClick={() => confirmModal.destroy()}
            //         />

            //         <SubmitButton
            //           key="yes"
            //           type="primary"
            //           submitName="Yes"
            //           className="defaultbutton"
            //           onClick={showConfirm}
            //         />
            //       </div>,
            //     ],
            //   });
            // }}
            onClick={showConfirm}
          />,
        ]}
        destroyOnClose
      >
        <Form form={form}>
          {/* Delegate User Info */}
          {givenDelegatedAccess &&
            delegatedAccessUsers?.length > 0 &&
            delegatedAccessInfo?.length > 0 && (
              <div className="mb-3 leading-7">
                {delegatedAccessUsers.map((user, i) => {
                  const info = delegatedAccessInfo[i];
                  return (
                    <div key={user.id} className="mb-4 pb-2 border-b">
                      <strong>Delegated To:</strong> {user.empName} (
                      <strong>Emp. Id. - {user.empID}</strong>)
                      <br />
                      <br />
                      <strong>Access Period: </strong>
                      {moment(info.fromDate).format("MMMM D, YYYY")} till{" "}
                      {moment(info.toDate).format("MMMM D, YYYY")}
                      <br />
                      <br />
                      <strong>Special Note:</strong> {info.specialNote || "—"}
                    </div>
                  );
                })}
              </div>
            )}
        </Form>
      </Modal>
    </>
  );
};

export default UndelegateAccess;
